import { OrgAdminLayout } from '@/components/organisms/org-admin';

export function OrgAdminPage() {
  return (
    <div className="flex h-full flex-col animate-fade-in bg-background">
      <OrgAdminLayout />
    </div>
  );
}

export default OrgAdminPage;
